// original at https://github.com/vueform/international-phone-masks
const phoneMasksBase = {
  "+93": {
    title: "Afghanistan",
    value: "+93",
    iso2: "AF",
    mask: "## ### ####",
  },

  "+355": {
    title: "Albania",
    value: "+355",
    iso2: "AL",
    mask: "## ### ####",
  },

  "+213": {
    title: "Algeria",
    value: "+213",
    iso2: "DZ",
    mask: "## ### ## ##",
  },

  "+1 (684)": {
    title: "American Samoa",
    value: "+1 (684)",
    iso2: "AS",
    mask: "###-####",
  },

  "+376": {
    title: "Andorra",
    value: "+376",
    iso2: "AD",
    mask: "### ###",
  },

  "+244": {
    title: "Angola",
    value: "+244",
    iso2: "AO",
    mask: "### ### ###",
  },

  "+1 (264)": {
    title: "Anguilla",
    value: "+1 (264)",
    iso2: "AI",
    mask: "###-####",
  },

  "+1 (268)": {
    title: "Antigua And Barbuda",
    value: "+1 (268)",
    iso2: "AG",
    mask: "###-####",
  },

  "+54": {
    title: "Argentina",
    value: "+54",
    iso2: "AR",
    mask: "9 ## ###-####",
  },

  "+374": {
    title: "Armenia",
    value: "+374",
    iso2: "AM",
    mask: "## ### ###",
  },

  "+297": {
    title: "Aruba",
    value: "+297",
    iso2: "AW",
    mask: "### ####",
  },

  "+43": {
    title: "Austria",
    value: "+43",
    iso2: "AT",
    mask: "## ### ####",
  },

  "+994": {
    title: "Azerbaijan",
    value: "+994",
    iso2: "AZ",
    mask: "## ### ## ##",
  },

  "+1 (242)": {
    title: "Bahamas",
    value: "+1 (242)",
    iso2: "BS",
    mask: "###-####",
  },

  "+973": {
    title: "Bahrain",
    value: "+973",
    iso2: "BH",
    mask: "#### ####",
  },

  "+880": {
    title: "Bangladesh",
    value: "+880",
    iso2: "BD",
    mask: "## ### ####",
  },

  "+1 (246)": {
    title: "Barbados",
    value: "+1 (246)",
    iso2: "BB",
    mask: "###-####",
  },

  "+375": {
    title: "Belarus",
    value: "+375",
    iso2: "BY",
    mask: "## ### ####",
  },

  "+32": {
    title: "Belgium",
    value: "+32",
    iso2: "BE",
    mask: "# ### ## ##",
  },

  "+501": {
    title: "Belize",
    value: "+501",
    iso2: "BZ",
    mask: "###-####",
  },

  "+229": {
    title: "Benin",
    value: "+229",
    iso2: "BJ",
    mask: "## ## ####",
  },

  "+1 (441)": {
    title: "Bermuda",
    value: "+1 (441)",
    iso2: "BM",
    mask: "###-####",
  },

  "+975": {
    title: "Bhutan",
    value: "+975",
    iso2: "BT",
    mask: "# ### ###",
  },

  "+591": {
    title: "Bolivia",
    value: "+591",
    iso2: "BO",
    mask: "# ### ####",
  },

  "+387": {
    title: "Bosnia And Herzegovina",
    value: "+387",
    iso2: "BA",
    mask: "## ###-####",
  },

  "+267": {
    title: "Botswana",
    value: "+267",
    iso2: "BW",
    mask: "## ### ###",
  },

  "+55": {
    title: "Brazil",
    value: "+55",
    iso2: "BR",
    mask: "## #### #####",
  },

  "+246": {
    title: "British Indian Ocean Territory",
    value: "+246",
    iso2: "IO",
    mask: "### ####",
  },

  "+673": {
    title: "Brunei Darussalam",
    value: "+673",
    iso2: "BN",
    mask: "### ####",
  },

  "+359": {
    title: "Bulgaria",
    value: "+359",
    iso2: "BG",
    mask: "## ### ####",
  },

  "+226": {
    title: "Burkina Faso",
    value: "+226",
    iso2: "BF",
    mask: "## ## ####",
  },

  "+257": {
    title: "Burundi",
    value: "+257",
    iso2: "BI",
    mask: "## ## ####",
  },

  "+855": {
    title: "Cambodia",
    value: "+855",
    iso2: "KH",
    mask: "## ### ###",
  },

  "+237": {
    title: "Cameroon",
    value: "+237",
    iso2: "CM",
    mask: "# ## ## ## ##",
  },

  "+238": {
    title: "Cape Verde",
    value: "+238",
    iso2: "CV",
    mask: "(##) ## ##",
  },

  "+1 (345)": {
    title: "Cayman Islands",
    value: "+1 (345)",
    iso2: "KY",
    mask: "###-####",
  },

  "+236": {
    title: "Central African Republic",
    value: "+236",
    iso2: "CF",
    mask: "## ## ####",
  },

  "+235": {
    title: "Chad",
    value: "+235",
    iso2: "TD",
    mask: "## ## ## ##",
  },

  "+56": {
    title: "Chile",
    value: "+56",
    iso2: "CL",
    mask: "# #### ####",
  },

  "+86": {
    title: "China",
    value: "+86",
    iso2: "CN",
    mask: "## #### ####",
  },

  "+61": {
    title: "Cocos (Keeling) Islands",
    value: "+61",
    iso2: "CC",
    mask: "## ### ###",
  },

  "+57": {
    title: "Colombia",
    value: "+57",
    iso2: "CO",
    mask: "# ### ####",
  },

  "+269": {
    title: "Comoros",
    value: "+269",
    iso2: "KM",
    mask: "## ## ##",
  },

  "+242": {
    title: "Congo",
    value: "+242",
    iso2: "CG",
    mask: "## ### ####",
  },

  "+243": {
    title: "Congo, Democratic Republic",
    value: "+243",
    iso2: "CD",
    mask: "## ### ####",
  },

  "+682": {
    title: "Cook Islands",
    value: "+682",
    iso2: "CK",
    mask: "## ###",
  },

  "+506": {
    title: "Costa Rica",
    value: "+506",
    iso2: "CR",
    mask: "#### ####",
  },

  "+225": {
    title: "Cote D'Ivoire",
    value: "+225",
    iso2: "CI",
    mask: "## ## ## ##",
  },

  "+385": {
    title: "Croatia",
    value: "+385",
    iso2: "HR",
    mask: "# ### ####",
  },

  "+53": {
    title: "Cuba",
    value: "+53",
    iso2: "CU",
    mask: "# ### ####",
  },

  "+357": {
    title: "Cyprus",
    value: "+357",
    iso2: "CY",
    mask: "## ### ###",
  },

  "+420": {
    title: "Czech Republic",
    value: "+420",
    iso2: "CZ",
    mask: "### ### ###",
  },

  "+45": {
    title: "Denmark",
    value: "+45",
    iso2: "DK",
    mask: "## ## ## ##",
  },

  "+253": {
    title: "Djibouti",
    value: "+253",
    iso2: "DJ",
    mask: "## ## ## ##",
  },

  "+1 (767)": {
    title: "Dominica",
    value: "+1 (767)",
    iso2: "DM",
    mask: "###-####",
  },

  "+593": {
    title: "Ecuador",
    value: "+593",
    iso2: "EC",
    mask: "## ### ####",
  },

  "+20": {
    title: "Egypt",
    value: "+20",
    iso2: "EG",
    mask: "# #### ####",
  },

  "+503": {
    title: "El Salvador",
    value: "+503",
    iso2: "SV",
    mask: "#### ####",
  },

  "+240": {
    title: "Equatorial Guinea",
    value: "+240",
    iso2: "GQ",
    mask: "## ### ####",
  },

  "+291": {
    title: "Eritrea",
    value: "+291",
    iso2: "ER",
    mask: "# ### ###",
  },

  "+372": {
    title: "Estonia",
    value: "+372",
    iso2: "EE",
    mask: "#### ####",
  },

  "+251": {
    title: "Ethiopia",
    value: "+251",
    iso2: "ET",
    mask: "## ### ####",
  },

  "+298": {
    title: "Faroe Islands",
    value: "+298",
    iso2: "FO",
    mask: "######",
  },

  "+679": {
    title: "Fiji",
    value: "+679",
    iso2: "FJ",
    mask: "### ####",
  },

  "+358": {
    title: "Finland",
    value: "+358",
    iso2: "FI",
    mask: "## ### ####",
  },

  "+33": {
    title: "France",
    value: "+33",
    iso2: "FR",
    mask: "# ## ## ## ##",
  },

  "+594": {
    title: "French Guiana",
    value: "+594",
    iso2: "GF",
    mask: "##### ####",
  },

  "+689": {
    title: "French Polynesia",
    value: "+689",
    iso2: "PF",
    mask: "## ## ##",
  },

  "+241": {
    title: "Gabon",
    value: "+241",
    iso2: "GA",
    mask: "# ## ## ##",
  },

  "+220": {
    title: "Gambia",
    value: "+220",
    iso2: "GM",
    mask: "### ####",
  },

  "+995": {
    title: "Georgia",
    value: "+995",
    iso2: "GE",
    mask: "## ### ####",
  },

  "+49": {
    title: "Germany",
    value: "+49",
    iso2: "DE",
    mask: "## ######",
  },

  "+233": {
    title: "Ghana",
    value: "+233",
    iso2: "GH",
    mask: "## ### ####",
  },

  "+350": {
    title: "Gibraltar",
    value: "+350",
    iso2: "GI",
    mask: "2## #####",
  },

  "+30": {
    title: "Greece",
    value: "+30",
    iso2: "GR",
    mask: "## ### ####",
  },

  "+299": {
    title: "Greenland",
    value: "+299",
    iso2: "GL",
    mask: "## ## ##",
  },

  "+1 (473)": {
    title: "Grenada",
    value: "+1 (473)",
    iso2: "GD",
    mask: "###-####",
  },

  "+1 (671)": {
    title: "Guam",
    value: "+1 (671)",
    iso2: "GU",
    mask: "###-####",
  },

  "+502": {
    title: "Guatemala",
    value: "+502",
    iso2: "GT",
    mask: "# ### ####",
  },

  "+224": {
    title: "Guinea",
    value: "+224",
    iso2: "GN",
    mask: "## ### ####",
  },

  "+245": {
    title: "Guinea-Bissau",
    value: "+245",
    iso2: "GW",
    mask: "# ### ###",
  },

  "+592": {
    title: "Guyana",
    value: "+592",
    iso2: "GY",
    mask: "### ####",
  },

  "+509": {
    title: "Haiti",
    value: "+509",
    iso2: "HT",
    mask: "## ## ####",
  },

  "+504": {
    title: "Honduras",
    value: "+504",
    iso2: "HN",
    mask: "#### ####",
  },

  "+852": {
    title: "Hong Kong",
    value: "+852",
    iso2: "HK",
    mask: "#### ####",
  },

  "+36": {
    title: "Hungary",
    value: "+36",
    iso2: "HU",
    mask: "## ### ####",
  },

  "+354": {
    title: "Iceland",
    value: "+354",
    iso2: "IS",
    mask: "### ####",
  },

  "+91": {
    title: "India",
    value: "+91",
    iso2: "IN",
    mask: "## #### ####",
  },

  "+62": {
    title: "Indonesia",
    value: "+62",
    iso2: "ID",
    mask: "## #### ####",
  },

  "+98": {
    title: "Iran, Islamic Republic Of",
    value: "+98",
    iso2: "IR",
    mask: "## #### ####",
  },

  "+964": {
    title: "Iraq",
    value: "+964",
    iso2: "IQ",
    mask: "## ### ####",
  },

  "+353": {
    title: "Ireland",
    value: "+353",
    iso2: "IE",
    mask: "## ### ####",
  },

  "+972": {
    title: "Israel",
    value: "+972",
    iso2: "IL",
    mask: "# ### ####",
  },

  "+39": {
    title: "Italy",
    value: "+39",
    iso2: "IT",
    mask: "## #### ####",
  },

  "+1 (876)": {
    title: "Jamaica",
    value: "+1 (876)",
    iso2: "JM",
    mask: "###-####",
  },

  "+81": {
    title: "Japan",
    value: "+81",
    iso2: "JP",
    mask: "##-####-####",
  },

  "+962": {
    title: "Jordan",
    value: "+962",
    iso2: "JO",
    mask: "# #### ####",
  },

  "+7 ": {
    title: "Kazakhstan",
    value: "+7 ",
    iso2: "KZ",
    mask: "7## ### ####",
  },

  "+254": {
    title: "Kenya",
    value: "+254",
    iso2: "KE",
    mask: "## #######",
  },

  "+686": {
    title: "Kiribati",
    value: "+686",
    iso2: "KI",
    mask: "## ###",
  },

  "+82": {
    title: "Korea",
    value: "+82",
    iso2: "KR",
    mask: "##-####-####",
  },

  "+965": {
    title: "Kuwait",
    value: "+965",
    iso2: "KW",
    mask: "#### ####",
  },

  "+996": {
    title: "Kyrgyzstan",
    value: "+996",
    iso2: "KG",
    mask: "## ### ####",
  },

  "+856": {
    title: "Lao People's Democratic Republic",
    value: "+856",
    iso2: "LA",
    mask: "## ### ###",
  },

  "+371": {
    title: "Latvia",
    value: "+371",
    iso2: "LV",
    mask: "#### ####",
  },

  "+961": {
    title: "Lebanon",
    value: "+961",
    iso2: "LB",
    mask: "# ### ###",
  },

  "+266": {
    title: "Lesotho",
    value: "+266",
    iso2: "LS",
    mask: "# ### ####",
  },

  "+231": {
    title: "Liberia",
    value: "+231",
    iso2: "LR",
    mask: "## ### ###",
  },

  "+218": {
    title: "Libyan Arab Jamahiriya",
    value: "+218",
    iso2: "LY",
    mask: "## ### ####",
  },

  "+423": {
    title: "Liechtenstein",
    value: "+423",
    iso2: "LI",
    mask: "### ####",
  },

  "+370": {
    title: "Lithuania",
    value: "+370",
    iso2: "LT",
    mask: "### #####",
  },

  "+352": {
    title: "Luxembourg",
    value: "+352",
    iso2: "LU",
    mask: "### ### ###",
  },

  "+853": {
    title: "Macao",
    value: "+853",
    iso2: "MO",
    mask: "#### ####",
  },

  "+389": {
    title: "Macedonia",
    value: "+389",
    iso2: "MK",
    mask: "## ### ###",
  },

  "+261": {
    title: "Madagascar",
    value: "+261",
    iso2: "MG",
    mask: "## ## #####",
  },

  "+265": {
    title: "Malawi",
    value: "+265",
    iso2: "MW",
    mask: "# ### ####",
  },

  "+60": {
    title: "Malaysia",
    value: "+60",
    iso2: "MY",
    mask: "##-### ####",
  },

  "+960": {
    title: "Maldives",
    value: "+960",
    iso2: "MV",
    mask: "###-####",
  },

  "+223": {
    title: "Mali",
    value: "+223",
    iso2: "ML",
    mask: "## ## ####",
  },

  "+356": {
    title: "Malta",
    value: "+356",
    iso2: "MT",
    mask: "#### ####",
  },

  "+692": {
    title: "Marshall Islands",
    value: "+692",
    iso2: "MH",
    mask: "###-####",
  },

  "+596": {
    title: "Martinique",
    value: "+596",
    iso2: "MQ",
    mask: "### ## ##",
  },

  "+222": {
    title: "Mauritania",
    value: "+222",
    iso2: "MR",
    mask: "## ## ####",
  },

  "+230": {
    title: "Mauritius",
    value: "+230",
    iso2: "MU",
    mask: "### ####",
  },

  "+52": {
    title: "Mexico",
    value: "+52",
    iso2: "MX",
    mask: "## #### ####",
  },

  "+691": {
    title: "Micronesia, Federated States Of",
    value: "+691",
    iso2: "FM",
    mask: "### ####",
  },

  "+373": {
    title: "Moldova",
    value: "+373",
    iso2: "MD",
    mask: "#### ####",
  },

  "+377": {
    title: "Monaco",
    value: "+377",
    iso2: "MC",
    mask: "## ## ## ##",
  },

  "+976": {
    title: "Mongolia",
    value: "+976",
    iso2: "MN",
    mask: "## ## ####",
  },

  "+382": {
    title: "Montenegro",
    value: "+382",
    iso2: "ME",
    mask: "## ### ###",
  },

  "+1 (664)": {
    title: "Montserrat",
    value: "+1 (664)",
    iso2: "MS",
    mask: "###-####",
  },

  "+258": {
    title: "Mozambique",
    value: "+258",
    iso2: "MZ",
    mask: "## ### ###",
  },

  "+95": {
    title: "Myanmar",
    value: "+95",
    iso2: "MM",
    mask: "## ### ###",
  },

  "+264": {
    title: "Namibia",
    value: "+264",
    iso2: "NA",
    mask: "## ### ####",
  },

  "+674": {
    title: "Nauru",
    value: "+674",
    iso2: "NR",
    mask: "### ####",
  },

  "+977": {
    title: "Nepal",
    value: "+977",
    iso2: "NP",
    mask: "## ### ####",
  },

  "+31": {
    title: "Netherlands",
    value: "+31",
    iso2: "NL",
    mask: "## ### ####",
  },

  "+687": {
    title: "New Caledonia",
    value: "+687",
    iso2: "NC",
    mask: "## ####",
  },

  "+505": {
    title: "Nicaragua",
    value: "+505",
    iso2: "NI",
    mask: "#### ####",
  },

  "+227": {
    title: "Niger",
    value: "+227",
    iso2: "NE",
    mask: "## ## ####",
  },

  "+234": {
    title: "Nigeria",
    value: "+234",
    iso2: "NG",
    mask: "## ### ####",
  },

  "+683": {
    title: "Niue",
    value: "+683",
    iso2: "NU",
    mask: "####",
  },

  "+672": {
    title: "Norfolk Island",
    value: "+672",
    iso2: "NF",
    mask: "## ###",
  },

  "+1 (670)": {
    title: "Northern Mariana Islands",
    value: "+1 (670)",
    iso2: "MP",
    mask: "###-####",
  },

  "+968": {
    title: "Oman",
    value: "+968",
    iso2: "OM",
    mask: "#### ####",
  },

  "+92": {
    title: "Pakistan",
    value: "+92",
    iso2: "PK",
    mask: "## ### ####",
  },

  "+680": {
    title: "Palau",
    value: "+680",
    iso2: "PW",
    mask: "### ####",
  },

  "+970": {
    title: "Palestinian Territory, Occupied",
    value: "+970",
    iso2: "PS",
    mask: "## ### ####",
  },

  "+507": {
    title: "Panama",
    value: "+507",
    iso2: "PA",
    mask: "### ####",
  },

  "+675": {
    title: "Papua New Guinea",
    value: "+675",
    iso2: "PG",
    mask: "## ### ###",
  },

  "+595": {
    title: "Paraguay",
    value: "+595",
    iso2: "PY",
    mask: "## ### ####",
  },

  "+51": {
    title: "Peru",
    value: "+51",
    iso2: "PE",
    mask: "## ### ###",
  },

  "+63": {
    title: "Philippines",
    value: "+63",
    iso2: "PH",
    mask: "## ### ####",
  },

  "+64": {
    title: "Pitcairn",
    value: "+64",
    iso2: "PN",
    mask: "## ### ####",
  },

  "+48": {
    title: "Poland",
    value: "+48",
    iso2: "PL",
    mask: "## ### ####",
  },

  "+351": {
    title: "Portugal",
    value: "+351",
    iso2: "PT",
    mask: "## ### ####",
  },

  "+974": {
    title: "Qatar",
    value: "+974",
    iso2: "QA",
    mask: "#### ####",
  },

  "+262": {
    title: "Reunion",
    value: "+262",
    iso2: "RE",
    mask: "##### ####",
  },

  "+40": {
    title: "Romania",
    value: "+40",
    iso2: "RO",
    mask: "## ### ####",
  },

  "+7": {
    title: "Russian Federation",
    value: "+7",
    iso2: "RU",
    mask: "(###) ###-##-##",
  },

  "+250": {
    title: "Rwanda",
    value: "+250",
    iso2: "RW",
    mask: "## ### ###",
  },

  "+290": {
    title: "Saint Helena",
    value: "+290",
    iso2: "SH",
    mask: "####",
  },

  "+1 (869)": {
    title: "Saint Kitts And Nevis",
    value: "+1 (869)",
    iso2: "KN",
    mask: "###-####",
  },

  "+1 (758)": {
    title: "Saint Lucia",
    value: "+1 (758)",
    iso2: "LC",
    mask: "###-####",
  },

  "+590": {
    title: "Saint Martin",
    value: "+590",
    iso2: "MF",
    mask: "### ####",
  },

  "+508": {
    title: "Saint Pierre And Miquelon",
    value: "+508",
    iso2: "PM",
    mask: "## ## ##",
  },

  "+1 (784)": {
    title: "Saint Vincent And Grenadines",
    value: "+1 (784)",
    iso2: "VC",
    mask: "###-####",
  },

  "+685": {
    title: "Samoa",
    value: "+685",
    iso2: "WS",
    mask: "## ####",
  },

  "+378": {
    title: "San Marino",
    value: "+378",
    iso2: "SM",
    mask: "#### ######",
  },

  "+239": {
    title: "Sao Tome And Principe",
    value: "+239",
    iso2: "ST",
    mask: "## ## ##",
  },

  "+966": {
    title: "Saudi Arabia",
    value: "+966",
    iso2: "SA",
    mask: "# #### ####",
  },

  "+221": {
    title: "Senegal",
    value: "+221",
    iso2: "SN",
    mask: "## ### ####",
  },

  "+381": {
    title: "Serbia",
    value: "+381",
    iso2: "RS",
    mask: "## #### ###",
  },

  "+248": {
    title: "Seychelles",
    value: "+248",
    iso2: "SC",
    mask: "# ### ###",
  },

  "+232": {
    title: "Sierra Leone",
    value: "+232",
    iso2: "SL",
    mask: "## ######",
  },

  "+65": {
    title: "Singapore",
    value: "+65",
    iso2: "SG",
    mask: "#### ####",
  },

  "+421": {
    title: "Slovakia",
    value: "+421",
    iso2: "SK",
    mask: "### ### ####",
  },

  "+386": {
    title: "Slovenia",
    value: "+386",
    iso2: "SI",
    mask: "# ### ## ##",
  },

  "+677": {
    title: "Solomon Islands",
    value: "+677",
    iso2: "SB",
    mask: "#####",
  },

  "+252": {
    title: "Somalia",
    value: "+252",
    iso2: "SO",
    mask: "# ### ###",
  },

  "+27": {
    title: "South Africa",
    value: "+27",
    iso2: "ZA",
    mask: "## ### ####",
  },

  "+500": {
    title: "South Georgia And Sandwich Isl.",
    value: "+500",
    iso2: "GS",
    mask: "#####",
  },

  "+34": {
    title: "Spain",
    value: "+34",
    iso2: "ES",
    mask: "### ### ###",
  },

  "+94": {
    title: "Sri Lanka",
    value: "+94",
    iso2: "LK",
    mask: "## ### ####",
  },

  "+249": {
    title: "Sudan",
    value: "+249",
    iso2: "SD",
    mask: "## ### ####",
  },

  "+597": {
    title: "Suriname",
    value: "+597",
    iso2: "SR",
    mask: "### ###",
  },

  "+47": {
    title: "Svalbard And Jan Mayen",
    value: "+47",
    iso2: "SJ",
    mask: "### ## ###",
  },

  "+268": {
    title: "Swaziland",
    value: "+268",
    iso2: "SZ",
    mask: "## ## ####",
  },

  "+46": {
    title: "Sweden",
    value: "+46",
    iso2: "SE",
    mask: "## ### ####",
  },

  "+41": {
    title: "Switzerland",
    value: "+41",
    iso2: "CH",
    mask: "## ### ####",
  },

  "+963": {
    title: "Syrian Arab Republic",
    value: "+963",
    iso2: "SY",
    mask: "## #### ###",
  },

  "+886": {
    title: "Taiwan",
    value: "+886",
    iso2: "TW",
    mask: "# #### ####",
  },

  "+992": {
    title: "Tajikistan",
    value: "+992",
    iso2: "TJ",
    mask: "## ### ####",
  },

  "+255": {
    title: "Tanzania",
    value: "+255",
    iso2: "TZ",
    mask: "## ### ####",
  },

  "+66": {
    title: "Thailand",
    value: "+66",
    iso2: "TH",
    mask: "# #### ####",
  },

  "+670": {
    title: "Timor-Leste",
    value: "+670",
    iso2: "TL",
    mask: "### ####",
  },

  "+228": {
    title: "Togo",
    value: "+228",
    iso2: "TG",
    mask: "## ### ###",
  },

  "+690": {
    title: "Tokelau",
    value: "+690",
    iso2: "TK",
    mask: "####",
  },

  "+676": {
    title: "Tonga",
    value: "+676",
    iso2: "TO",
    mask: "## ###",
  },

  "+1 (868)": {
    title: "Trinidad And Tobago",
    value: "+1 (868)",
    iso2: "TT",
    mask: "###-####",
  },

  "+216": {
    title: "Tunisia",
    value: "+216",
    iso2: "TN",
    mask: "## ### ###",
  },

  "+90": {
    title: "Turkey",
    value: "+90",
    iso2: "TR",
    mask: "(###) ### ####",
  },

  "+993": {
    title: "Turkmenistan",
    value: "+993",
    iso2: "TM",
    mask: "# ### ###",
  },

  "+1 (649)": {
    title: "Turks And Caicos Islands",
    value: "+1 (649)",
    iso2: "TC",
    mask: "###-####",
  },

  "+688": {
    title: "Tuvalu",
    value: "+688",
    iso2: "TV",
    mask: "## ###",
  },

  "+256": {
    title: "Uganda",
    value: "+256",
    iso2: "UG",
    mask: "### ### ###",
  },

  "+380": {
    title: "Ukraine",
    value: "+380",
    iso2: "UA",
    mask: "## ### ####",
  },

  "+971": {
    title: "United Arab Emirates",
    value: "+971",
    iso2: "AE",
    mask: "# ### ####",
  },

  "+44": {
    title: "United Kingdom",
    value: "+44",
    iso2: "GB",
    mask: "## #### ####",
  },

  "+1": {
    title: "United States",
    value: "+1",
    iso2: "US",
    mask: "(###) ###-####",
  },

  "+598": {
    title: "Uruguay",
    value: "+598",
    iso2: "UY",
    mask: "# ### ## ##",
  },

  "+998": {
    title: "Uzbekistan",
    value: "+998",
    iso2: "UZ",
    mask: "## ### ####",
  },

  "+678": {
    title: "Vanuatu",
    value: "+678",
    iso2: "VU",
    mask: "## ####",
  },

  "+58": {
    title: "Venezuela",
    value: "+58",
    iso2: "VE",
    mask: "###-#######",
  },

  "+84": {
    title: "Viet Nam",
    value: "+84",
    iso2: "VN",
    mask: "## #### ###",
  },

  "+1 (284)": {
    title: "Virgin Islands, British",
    value: "+1 (284)",
    iso2: "VG",
    mask: "###-####",
  },

  "+1 (340)": {
    title: "Virgin Islands, U.S.",
    value: "+1 (340)",
    iso2: "VI",
    mask: "###-####",
  },

  "+681": {
    title: "Wallis And Futuna",
    value: "+681",
    iso2: "WF",
    mask: "## ####",
  },

  "+212": {
    title: "Western Sahara",
    value: "+212",
    iso2: "EH",
    mask: "5288-#####",
  },

  "+967": {
    title: "Yemen",
    value: "+967",
    iso2: "YE",
    mask: "# ### ###",
  },

  "+260": {
    title: "Zambia",
    value: "+260",
    iso2: "ZM",
    mask: "## ### ####",
  },

  "+263": {
    title: "Zimbabwe",
    value: "+263",
    iso2: "ZW",
    mask: "# ######",
  },
};

export const phoneMasks = {
  ...phoneMasksBase,
  "+1": {
    title: "United States/Canada",
    value: "+1",
    iso2: "US/CA",
    mask: "(###) ###-####",
  },
};

export const mappedIso2 = [
  ...Object.values(phoneMasksBase),
  {
    title: "Canada",
    value: "+1",
    iso2: "CA",
    mask: "(###) ###-####",
  },
].map((item) => ({ title: item.title, value: item.iso2 }));

export const getFlagFromIso2 = (iso2: string): string => {
  const code = iso2.split("/")[0]?.toUpperCase();
  if (!code || code.length !== 2) {
    return "";
  }
  return String.fromCodePoint(
    ...[...code].map((character) => 127_397 + (character.codePointAt(0) ?? 0))
  );
};

export type PhoneMaskItem = { title: string; value: string; subtitle: string };

export const countryItems: PhoneMaskItem[] = Object.values(phoneMasks).map((item) => {
  const flag = getFlagFromIso2(item.iso2);
  return {
    title: flag ? `${flag} ${item.title}` : item.title,
    value: item.value,
    subtitle: item.value,
  };
});

export const countryItemProps = (val: PhoneMaskItem) => ({
  title: val.title,
  value: val.value,
  subtitle: val.subtitle,
});
